import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { ContactService } from 'src/app/rest_services/contact.service';
import { CustomersService } from 'src/app/rest_services/customers.service';
import { phoneNumberValidator } from 'src/app/validators/phone-number.validator';

@Component({
  selector: 'app-edit-contact',
  templateUrl: './edit-contact.component.html',
  styleUrls: ['./edit-contact.component.css']
})
export class EditContactComponent implements OnInit {

  updateContactForm!:FormGroup;
  loadingAddingContact: boolean = false;
  addError:any;
  addedMsg:any ='';
  contact:any;
  uuid:any;
  retrieveContactSubscription!:Subscription;
  retrieveContactLoader:boolean = true;

  constructor(private formBuilder: FormBuilder,
    private contactService: ContactService,
    private route : ActivatedRoute,
    private router : Router,
    private location :Location, 
    private customersService :CustomersService) { }

  ngOnInit(): void {
    this.uuid = this.route.snapshot.params['uuid'];
    this.retrieveContact(this.uuid);
    this.updateContactForm = this.formBuilder.group({
      'owner': [''],
      'nomCompte': [''],
      'civilite': ['', Validators.required],
      'prenom': ['', Validators.required],
      'nom': ['', Validators.required],
      'telephoneDomicile': ['', phoneNumberValidator()],
      'telephoneMobile': ['',[phoneNumberValidator(), Validators.required]],
      'telephoneAutre': ['', phoneNumberValidator()],
      'serviceContact': [''],
      'fonctionContact': [''],
      'email': ['', [Validators.required, Validators.email]],
      'responsableHierarchique': [''],
      'originePiste': [''],
      'langue': [''],
      'adresseRue': [''],
      'codePostal': [''],
      'ville': [''],
      'pays': [''],
      'autreAdresseRue': [''],
      'autreCodePostal': [''],
      'autreVille': [''],
      'autrePays': [''],
      'quitterSociete': [],
      'invalideContact': [],
      'garderContact': [],
      'description': ['']
    });
    this.getAllCustomers();
  }

  updateContact() {
    $("html, body").animate({scrollTop:0});
    this.loadingAddingContact= true;
    const requestBody = this.updateContactForm.value;
    const contactUUID = this.uuid; 
    this.contactService.updateContact(contactUUID, requestBody).subscribe(
      (response: any) => {
        this.loadingAddingContact= false;
        if(response.code== "2eae402f9f4d1fe2c1b2da4287fd47a5"){
          $("#contact_updated").show();
          $('.alert-gradient').removeClass().addClass('fadeIn animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
          });
          setTimeout(()=>{
            $("#contact_updated").hide();
            this.location.back();
          }, 2000);
        }else if (response.code= "70b96ceb00af1d26a71ffbfdf9ebdde6"){
          this.addError =". Une erreur s'est produite lors de la modification"; 
          $("#contact_not_updated").show();
          $('.alert-gradient').removeClass().addClass('fadeIn animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
          });
          setTimeout(()=>{
            $("#contact_not_updated").hide();
          }, 3000);
        }
      },
      (error: any) => {
        console.error('Error updating contact:', error);
      }
    );
  }

  retrieveContact(uuid:any){
    this.retrieveContactSubscription = this.contactService.getContactDetail(uuid).subscribe(
      (data:any) => {
        this.retrieveContactLoader = false;
        if (data.code == "2eae402f9f4d1fe2c1b2da4287fd47a5"){
          this.contact = data.contact;
          this.updateContactForm.patchValue({
            'owner': this.contact.owner,
            'nomCompte': this.contact.accountName,
            'civilite': this.contact.civility,
            'prenom': this.contact.firstName,
            'nom': this.contact.lastName,
            'telephoneDomicile': this.contact.homePhone,
            'telephoneMobile': this.contact.mobilePhone,
            'telephoneAutre': this.contact.otherPhone,
            'serviceContact': this.contact.contactService,
            'fonctionContact': this.contact.contactFunction,
            'email': this.contact.emailAddress,
            'responsableHierarchique': this.contact.hierarchicalSupervisor,
            'originePiste': this.contact.leadOrigin,
            'langue': this.contact.language,
            'adresseRue': this.contact.streetAddress,
            'codePostal': this.contact.postalCode,
            'ville': this.contact.city,
            'pays': this.contact.country,
            'autreAdresseRue': this.contact.otherStreetAddress,
            'autreCodePostal': this.contact.otherPostalCode,
            'autreVille': this.contact.otherCity,
            'autrePays': this.contact.otherCountry,
            'quitterSociete': this.contact.leaveCompany,
            'invalideContact': this.contact.invalidContact,
            'garderContact':this.contact.keepContact,
            'description': this.contact.description,
          });
          // Manually adjust floating labels after patching values
        this.adjustFloatingLabels();
        }
        else if (data.code == "70b96ceb00af1d26a71ffbfdf9ebdde6"){
          this.router.navigate(['/contacts'])
        }
      },
      (error: any) => {
        console.log(error);
      }
    );
  }
// Function to manually adjust floating labels
adjustFloatingLabels() {
  const inputFields = document.querySelectorAll('.mdl-textfield__input');
  inputFields.forEach((input) => {
    // Type casting to HTMLInputElement
    const inputElement = input as HTMLInputElement;
    
    const parentDiv = inputElement.parentElement;
    if (inputElement.value.trim() !== '') {
      parentDiv?.classList.add('is-focused', 'is-dirty');
    } else {
      parentDiv?.classList.remove('is-focused', 'is-dirty');
    }
  });
}


refClients:any[] =[];
  getAllCustomers(){
    var glob=this;
    this.customersService.getAllCustomers();
    this.customersService.customersSubject.subscribe(
      ( data: any ) => {
        if(data.code=="a12d89f623abb138ebacc91b3703326a" && data.customers !=null){
          var newArrayAllCustomers:any[] = [];
          for(let cust of data.customers){
            var sites:any[]=[];
            var site:any = {
              city:cust.customer_city,
              uuid:cust.city,
              customer:cust.customer
            }
            sites.push(site)
            var customer = {
              rs_customer:cust.customer_rs,
              city_uuid:cust.customer_city,
              uuid:cust.customer,
              sites:sites
            }
            newArrayAllCustomers.push(customer);
          }
          setTimeout(()=>{
            this.refClients = newArrayAllCustomers;
            (<any>$( "#nomCompte" )).autocomplete({
              source: function ( request:any, response:any ) {
                response($.map(glob.refClients, function (obj, key) {
                  var name = obj.rs_customer.toUpperCase();
                  if (name.indexOf(request.term.toUpperCase()) != -1) {				
                    return {
                      label: obj.rs_customer,
                      value: obj.rs_customer // Value
                    }
                  } else {
                    return null;
                  }
                }));			
              },    
              focus: function(event:any, ui:any) {
                event.preventDefault();
              },
              // Once a value in the drop down list is selected, do the following:
              select: function(event:any, ui:any) {
                      event.preventDefault();
                // place the person.given_name value into the textfield called 'select_origin'...
                glob.updateContactForm.controls['nomCompte'].setValue(ui.item.value);             
                $('#nomCompte').val(ui.item.label);
                // ... any other tasks (like setting Hidden Fields) go here...
              }
            });
          }, 1000);
        }
        
      },
    )  
  }
}
